import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTalkT } from './useTalkT'
import { helpApi } from '@/services/api/help'
import { loadSpeaker } from './talkSpeaker'
import { isOfflineZettelId } from './offlineZettel'

export function TranscriptRetryButton({
  conversationId,
  zettelId,
  pending,
  className = 'text-xs underline min-h-11',
}: {
  conversationId?: string | null
  zettelId?: string | null
  pending: boolean
  className?: string
}) {
  const t = useTalkT()
  const qc = useQueryClient()
  const mut = useMutation({
    mutationFn: () => helpApi.retryZettel(conversationId!, zettelId!, loadSpeaker()),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['help-me'] })
      void qc.invalidateQueries({ queryKey: ['help-my-zettel'] })
      void qc.invalidateQueries({ queryKey: ['help-zettel'] })
      void qc.invalidateQueries({ queryKey: ['help-pairs'] })
    },
  })
  if (!pending || !zettelId || !conversationId || isOfflineZettelId(zettelId)) return null
  return (
    <span className="block">
      <button
        type="button"
        className={className}
        disabled={mut.isPending}
        onClick={e => {
          e.stopPropagation()
          mut.mutate()
        }}
      >
        {t('talk_transcript_retry')}
      </button>
      {mut.isError && (
        <span className="block text-xs text-red-500">{t('talk_transcript_retry_fail')}</span>
      )}
    </span>
  )
}
